namespace GeniuzPOS.Points {
    export namespace PrPointCampaignService {
        export const baseUrl = 'Points/PrPointCampaign';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PrPointCampaignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PrPointCampaignRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Points/PrPointCampaign/Retrieve",
            List = "Points/PrPointCampaign/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PrPointCampaignService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
